import React from 'react';
import ReactDOM from 'react-dom';
import App from './views/App';
// import App from './views/AppMaintenance';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
